import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToolbarItem } from '@shared/interfaces/tool-bar-item.interface';
import { faPlus, faUpload, faSearch, faRemove } from '@fortawesome/free-solid-svg-icons';
import { BenchTemplateSearchResult } from '@shared/interfaces/gridrows/bench-template.interface';
import { CancelEvent, CellClickEvent, ColumnBase, ColumnReorderEvent, EditEvent, GridComponent, DataStateChangeEvent, GridDataResult, PagerSettings, SaveEvent, SelectionEvent, SelectableSettings } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { ViewControl } from '../../../shared/ui/controls/view-control.model';
import { GridDataBindingDirective } from '../../../shared/directives/grid-data-binding.directive';
import { BenchTemplateService } from '../services/bench-template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { BenchTemplateItemSearchResult } from '../../../shared/interfaces/gridrows/bench-tempalte-item.interface';
import { BaseDetailForm } from '../../../shared/ui/base-detail-form';
import { BenchTemplate } from '@shared/interfaces/entities/bench-template.interface';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { UiGroupControl } from '../../../shared/ui/controls/ui-group-control.model';
import { ViewRowControl } from '../../../shared/ui/controls/view-row-control.model';
import { TextAreaControl } from '../../../shared/ui/controls/textarea-control.model';
import { DateControl } from '../../../shared/ui/controls/date-control.model';
import { DetailService } from '../../../core/services/detail.service';
import { BenchTemplateStatus, SecurityRole } from '../../../shared/literals/shared.literal';
import { UiColumn } from '../../../shared/ui/ui-column';
import { GridSettings } from '../../../shared/interfaces/grid-settings.interface';
import { ItemUniqueComponentSearchResult } from '../../../shared/interfaces/gridrows/item-unique-component.interface';
import { FeedbackMessageService } from '@shared/services/feedback-message.service';
import { ClientEngineerSelect } from '../../../shared/ui/select-controls/client-engineer-select.model';
import { EpcEngineerSelect } from '../../../shared/ui/select-controls/epc-engineer-select.model';
import { AuthUserFilter } from '../../../shared/interfaces/select-filters/auth-user-filter.interface';
import { Permission } from '@core/literals/permission.literal';
import { SVGIcon, saveIcon, cancelIcon, pencilIcon, xIcon, arrowRightIcon, checkIcon, clipboardIcon } from '@progress/kendo-svg-icons';
import { ReadOnlyIf, ReadOnlyProperty, RequiredIf, VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { StateSelect } from '../../../shared/ui/select-controls/state-select.model';
import { CountrySelect } from '../../../shared/ui/select-controls/country-select.model';
import { EditorControl } from '../../../shared/ui/controls/editor-control.model';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { SelectLookupService } from '../../../shared/services/select-lookup.service';
import { takeUntil } from 'rxjs';
import { BenchTemplateReassignItemComponent } from '../bench-template-reassign-item/bench-template-reassign-item.component';
import { WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { BenchTemplateItem } from '../../../shared/interfaces/entities/bench-template-item.interface';
import { INotificationService } from '../../../shared/services/inotification.service';
import { CountryFilter } from '../../../shared/interfaces/select-filters/country-filter.interface';
import { StateFilter } from '../../../shared/interfaces/select-filters/state-filter.interface';
import { OnChangeArgs } from '../../../shared/components/select-field/select-field.component';
import { ContextMenuItem } from '../../../shared/interfaces/contex-menu-item.interface';
import { ContextMenuComponent, ContextMenuSelectEvent } from '@progress/kendo-angular-menu';
import { faClipboard, faCopy } from '@fortawesome/free-solid-svg-icons';
import { Clipboard } from '@angular/cdk/clipboard';
import { BenchTemplateAddItemComponent } from '../bench-template-add-item/bench-template-add-item.component';
import { BenchTemplateRemoveItemsComponent } from '../bench-template-remove-items/bench-template-remove-items.component';

@Component({
    selector: 'app-bench-template',
    templateUrl: './bench-template.component.html',
    styleUrls: ['./bench-template.component.css'],
    standalone: false
})
export class BenchTemplateComponent extends BaseDetailForm<BenchTemplate> implements OnInit {

  @ViewChild(GridDataBindingDirective) db: GridDataBindingDirective;
  @ViewChild('grid') public orderGrid: GridComponent;
  @ViewChild('orderSection', { read: ViewContainerRef, static: false }) public orderSection: ViewContainerRef;
  @ViewChild("gridMenu") public gridContextMenu: ContextMenuComponent;
  contextMenuItems: ContextMenuItem[] = [];


  public state: State = { skip: 0, take: 100 };

  id: string;
  subGridSettings: GridSettings<ItemUniqueComponentSearchResult>;
  gridState: State = { sort: [], skip: 0, take: 1000 }

  public pageSize: number = 100;
  pagerSettings: PagerSettings;
  status: number;
  toolbarItemList: ToolbarItem[] = [];

  newColumnOrder: ColumnBase[] = [];

  removeDefaultToolbarItems: boolean;
  showSaveButton: boolean;
  showRemoveButton: boolean;
  canMarkBenchTemplateReadyToBench: boolean;
  canMarkBenchTemplateBenched: boolean;
  canMarkBenchTemplateFinalized: boolean;
  canAssignEPCEngineerToBenchTemplate: boolean;

  showExtraInfo: boolean = false;

  openDialog: boolean = false;
  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = saveIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;
  dialogStatus: string = "";

  finalizeWarningDescription: string = "Attention! Please make sure you've completed your configuration for all devices before finalizing the bench process. Once finalized, your order will be prepped for shipment.";

  public formGroups: FormGroup = new FormGroup({ items: new FormArray([]) });

  public editIcon: SVGIcon = pencilIcon;
  public saveIcon: SVGIcon = saveIcon;
  public cancelIcon: SVGIcon = cancelIcon;

  benchTemplateStatus: string;
  showCustomField1: boolean;
  customField1Title: string;

  showInlineAction: boolean;
  isEpcEngineer: boolean;
  showBenchTemplateWarning: boolean;

  showConnectionInfo: boolean;
  showHostnameSoftwareInstructions: boolean;

  data: any[] = [];

  public isEdited = false;

  public current = 0;

  public steps = [
    { label: "Pending", svgIcon: arrowRightIcon },
    { label: "Awaiting Assignment", svgIcon: arrowRightIcon },
    { label: "Ready To Bench", svgIcon: arrowRightIcon },
    { label: "Benched", svgIcon: arrowRightIcon },
    { label: "Finalized", svgIcon: checkIcon },
  ];

  selectedRow?: BenchTemplateItem;
  public lastSelectedColumnName: number;
  public lastSelectedItem: any;
  public mySelection: number[] = [];
  public lastSelectedRowIndex: number;
  public lastPointerEvent: PointerEvent;
  private rowIndex: any;
  private rowId: string;
  private contextItem: any;
  public showCommandRow: boolean = false;

  public selectableSettings: SelectableSettings = { mode: "multiple", drag: true };

  stateSelect = new StateSelect("stateId", "State", null);
  constructor(private activatedRouter: ActivatedRoute,
              private router: Router,
              private benchTemplateService: BenchTemplateService,
              private windowService: WindowService,
              private feedback: FeedbackMessageService,
              private notificationService: INotificationService,
              private cd: ChangeDetectorRef,
              private clipboard: Clipboard,
              private auth: AuthenticationService,
              private feedbackSerivce: FeedbackMessageService,
              private detailService: DetailService<BenchTemplateItem>) {
    		  super();

    this.name = "Bench Template";
    this.apiController = "BenchTemplate";
    this.keyFieldName = "id";
    this.breadCrumbPropertyNames = ["orderNumber"];
    this.initializeUiControls();

    this.activatedRouter.params.subscribe(params => this.id = params['id']);
  }

  ngOnInit() {
    var session = this.auth.getSession();
    this.stateSelect.clearDataOnOpen = true

    this.removeDefaultToolbarItems = (!this.auth.canPerformAction(Permission.UpdateBenchTemplate));

    this.isEpcEngineer = session?.securityRoleId == Number(SecurityRole.EPCEngineer);

    this.canMarkBenchTemplateReadyToBench = (this.auth.canPerformAction(Permission.MarkBenchTemplateAsReadyToBench));
    this.canMarkBenchTemplateBenched = (this.auth.canPerformAction(Permission.MarkBenchTemplateAsBenched));
    this.canMarkBenchTemplateFinalized = (this.auth.canPerformAction(Permission.MarkBenchTemplateAsFinalized));
    this.canAssignEPCEngineerToBenchTemplate = (this.auth.canPerformAction(Permission.AssignEPCEngineerToBenchTemplate));

    //if we need to specify which default buttons to keep or remove you can do that here
    //An engineer should be able to save but not remove a bench template
    this.showSaveButton = (this.auth.canPerformAction(Permission.UpdateBenchTemplate));
    this.showRemoveButton = this.auth.isAdmin();

    this.pagerSettings = {
      previousNext: true,
      position: "bottom",
      info: true,
      type: "input",
      pageSizes: false
    };


    this.subGridSettings =
    {
      gridName: "componentGrid",
      showSubGrid: false,
      columns: this.getGridColumns(),
      subGridDataProperty: "componentsList"
    };

    var copyText: ContextMenuItem = {
      title: "Copy Text",
      iconClass: clipboardIcon,
      action: this.copyText.bind(this),
    }

    var copyUniqnums: ContextMenuItem = {
      title: "Copy Uniqnums",
      iconClass: clipboardIcon,
      action: () => { this.copyUniqnums(); }
    }

    this.contextMenuItems.push(copyText, copyUniqnums); 

  }

  ngAfterViewInit(): void {

    this.benchTemplateService.getBenchTemplateColumnOrder().subscribe((data: string[]) => {
      var sortedColumns = this.orderGrid.columns.toArray().sort((a, b) => data.indexOf(a.title) - data.indexOf(b.title));

      sortedColumns.forEach(col => {
        var gridColumn = sortedColumns.filter(gc => Reflect.get(gc, 'title') == col.title)[0];
        if (gridColumn) {
          this.orderGrid.reorderColumn(gridColumn, this.orderGrid.columns.length - 1); 
        }
      });
    });
  }

  onColumnReorder(e: ColumnReorderEvent): void {
    if (this.newColumnOrder.length == 0) {
      this.newColumnOrder = this.orderGrid.columns.toArray();
    }

    const reorderedColumn = this.newColumnOrder.splice(e.oldIndex, 1)[0];
    this.newColumnOrder.splice(e.newIndex, 0, reorderedColumn);
  }


  public saveColumnReorder(grid: GridComponent): void {
    var columnOrderList = this.newColumnOrder.map(column => column.title);

    //call function to save
    this.benchTemplateService.saveBenchTemplateColumnOrder(columnOrderList).subscribe((data => {
      if (data.wasSuccessful) {
        this.notificationService.show({ title: "Success!", description: data.message, type: "success" });
      } else {
        this.notificationService.show({ title: "Error", description: data.message, type: "error" });
      }
    }));
  }

  reorderColumns(columns: any[], order: string[]): any[] {
    const orderedColumns = new Array;
    order.forEach(field => {
      const column = columns.find(col => col.field === field);
      if (column) {
        orderedColumns.push(column);
      }
    });

    columns.forEach(col => {
      if (!orderedColumns.includes(col)) {
        orderedColumns.push(col);
      }
    });
    return orderedColumns;
  }

  showLoadingProgress() {
    var container = document.getElementById('loadingOrderContainer');
    if (container) {
      container.style.display = "block";
    }
  }

  hideLoadingProgress() {
    var container = document.getElementById('loadingOrderContainer');
    if (container) {
      container.style.display = "none";
    }
  }

  private getGridColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var uniqnum = new UiColumn("uniqnum", "Uniqnum", 160);
    var name = new UiColumn("name", "Name", 160);
    var serial = new UiColumn("serialNumber", "Serial Number", 160);
    var notes = new UiColumn("notes", "Notes", 160);

    cols.push(uniqnum, name, serial, notes);

    return cols;
  }

  openConfirmDialog(status: string, extraInformation: string) {
    this.openDialog = true;
    this.dialogStatus = status;

    if (extraInformation != "") {
      this.showExtraInfo = true;
    }
  }

  closeConfirmDialog() {
    this.openDialog = false;
    this.showExtraInfo = false;
  }

  onGridDoubleClicked(e: MouseEvent): void {
    var canReAssignUniqueNumbers = this.auth.canPerformAction(Permission.ReAssignUniqueNumbers) && this.entity.benchTemplateStatusId != Number(BenchTemplateStatus.Finalized)

    if (canReAssignUniqueNumbers) {
      var event = window.event;
      event?.preventDefault();

      var selectedRow = this.orderGrid.activeRow.dataItem;

      let x = window.scrollX;
      let y = window.scrollY;

      window.onscroll = () => {
        window.scrollTo(x, y);
      }

      setTimeout(() => {
        window.onscroll = () => { };
      });

      var options: WindowSettings = {
        title: 'Re-assign item ' + selectedRow.epcUniqueIdentifier,
        width: 500,
        height: 300,
        content: BenchTemplateReassignItemComponent,
        draggable: true,
        resizable: true,
        top: (e as PointerEvent).pageY - 200
      };


      const win = this.windowService.open(options);

      const componentData = win.content.instance;
      componentData.entity = selectedRow;

      componentData.submitForm.subscribe((formData: FormGroup) => {
        var entity = formData.value as BenchTemplateItem;

        this.benchTemplateService.reassignBenchTemplateItem(entity.id, entity.itemUniqueId).subscribe((response) => {
          if (response.wasSuccessful) {
            this.feedbackSerivce.give({ text: response.message ?? "Saved Successfully!", status: "success" });
          } else {
            this.feedbackSerivce.give({ text: response.message ?? "Error!", status: "error" });
          }

          win.close();
        });

      });
    } else {
      return;
    }
  }

  addItemsToBenchTemplate() {
    var e = window.event;
    e?.preventDefault();

    var settings: WindowSettings = {
      title: 'Add Items',
      width: 550,
      height: 300,
      content: BenchTemplateAddItemComponent,
      draggable: true,
      resizable: false
      //top: 400
    };

    const win = this.windowService.open(settings);
    win.content.instance.id = this.entity.id;

    win.content.instance.submitForm.subscribe((formData: any) => {
      var data = formData.value;

      this.benchTemplateService.addItemBenchTemplate(Number(this.id), data.availableItems).subscribe((data => {
        if (data.wasSuccessful) {
          this.notificationService.show({ type: 'success', title: "Success", description: "Success!" });
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          this.notificationService.show({ type: 'error', title: "Error", description: data.message ?? "Something Went Wrong!" });
        }

        win.close();
      }));
    });

  }

  removeItemsFromBenchTemplate() {
    var e = window.event;
    e?.preventDefault();

    var settings: WindowSettings = {
      title: 'Remove Items',
      width: 550,
      height: 300,
      content: BenchTemplateRemoveItemsComponent,
      draggable: true,
      resizable: false
      //top: 400
    };

    const win = this.windowService.open(settings);
    win.content.instance.id = this.entity.id;

    win.content.instance.submitForm.subscribe((formData: any) => {
      var data = formData.value;

      this.benchTemplateService.removeItemsFromBenchTemplate(Number(this.id), data.itemsOnBenchTemplate).subscribe((data => {
        if (data.wasSuccessful) {
          this.notificationService.show({ type: 'success', title: "Success", description: "Success!" });
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          this.notificationService.show({ type: 'error', title: "Error", description: data.message ?? "Something Went Wrong!" });
        }

        win.close();
      }));
    });

  }

  public setBenchTemplateStatus(): void {
    this.dialogLoader = true;
    this.dialogIcon = false;

    this.benchTemplateService.setBenchTemplateStatus(Number(this.id), this.entity.benchTemplateStatusId).subscribe((data => {
      if (data.wasSuccessful) {
        this.openDialog = false;
        this.feedback.give({ text: "Success! Email has been sent.", status: "success" });
        setTimeout(() => { window.location.reload() }, 1000);

      } else {
        this.openDialog = false;
        this.feedback.give({ text: "Error! " + data.message, status: "error" });
      }
    }));
  }
  public saveHandler(grid: GridComponent): void {
    this.isEdited = false;
    this.saveChanges(grid);
  }

  public saveChanges(grid: GridComponent) {
    let rows: any = grid.data;

    rows.forEach((_item: any, index: any) => {
      this.benchTemplateService.saveBenchTemplateItem(_item).subscribe((data => {
        if (data.wasSuccessful) {
        } else {
          this.feedback.give({ text: "Error! " + data.message, status: "error" });
        }
      }));

      grid.closeRow(index);
    });
  }

  public cancelHandler(grid: GridComponent): void {
    this.isEdited = false;
    let rows: any = grid.data;

    rows.forEach((_item : any, index : any) => {
      grid.closeRow(index);
    });
  }

  public editHandler(grid: GridComponent): void {
    this.isEdited = true;
    this.updateGroups(grid);
    grid.editRow(0);
  }

  public createFormGroup = (dataItem: any) =>
    new FormGroup({
      hostName: new FormControl(dataItem.hostName),
      softwareVersions: new FormControl(dataItem.softwareVersions),
      instructions: new FormControl(dataItem.instructions),
    });

  public updateGroups(grid: GridComponent): void {
    let rows: any = grid.data;

    (this.formGroups.get("items") as FormArray).clear();
    rows.forEach((_item: any, index : any) => {
      let group = this.createFormGroup(rows[index]);
      (this.formGroups.get("items") as FormArray).push(group);
      if (this.isEdited) {
        grid.editRow(index, group);
      }
    });
  }

  onCountryChange(args: OnChangeArgs): void {
    var filters: StateFilter = {
      countryId: args.value.id
    };
    this.stateSelect.filters = filters;
    this.cd.detectChanges();
  }

  entityLoaded(): void {
    if (this.entity) {
      var session = this.auth.getSession();

      var stateFilters: StateFilter = {
        countryId: this.entity.countryId
      };

      this.stateSelect.filters = stateFilters;

      this.current = this.entity.orderStatus;

      //If this is an epc engineer and they are NOT assigned to this bench template, redirect them back to the Bench Template search page
      if (session?.securityRoleId == Number(SecurityRole.EPCEngineer) && this.entity.epcEngineerId != session.userId) {
        this.router.navigate(['/BenchTemplate']);
      }

      if (session?.securityRoleId == Number(SecurityRole.Engineer) && this.entity.clientEngineerId != session.userId) {
        this.router.navigate(['/BenchTemplate']);
      }

      this.showCustomField1 = this.entity.showCustomField1;

      this.showBenchTemplateWarning = this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Benched);

      this.showHostnameSoftwareInstructions = this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Pending) && this.canMarkBenchTemplateReadyToBench;
      this.showConnectionInfo = this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.ReadyBenched) && this.canMarkBenchTemplateBenched && !this.auth.isClientAdmin();

      if (this.showHostnameSoftwareInstructions) {
        this.showInlineAction = true;
      } else if (this.showConnectionInfo) {
        this.showInlineAction = true;
      } else {
        this.showInlineAction = false;
      }



      var showReadyToBenchBtn: boolean = (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Pending) && this.canMarkBenchTemplateReadyToBench);
      var showAssignBtn: boolean = (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.AwaitingAssignment) && this.canAssignEPCEngineerToBenchTemplate);
      var showBenchedBtn: boolean = (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.ReadyBenched) && this.canMarkBenchTemplateBenched);
      var showFinalizedBtn: boolean = (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Benched) && this.canMarkBenchTemplateFinalized);


      var toolbarAddItems: ToolbarItem = {
        text: 'Add Item(s)',
        icon: faPlus,
        hasMultiple: false,
        cssClass: "greenDarkBg",
        action: () => { this.addItemsToBenchTemplate(); }
      };

      var toolbarRemoveItems: ToolbarItem = {
        text: 'Remove Item(s)',
        icon: faRemove,
        hasMultiple: false,
        cssClass: "danger",
        action: () => { this.removeItemsFromBenchTemplate(); }
      };

      if (this.auth.isAdmin() == true) {
        this.toolbarItems.push(toolbarAddItems);
        this.toolbarItems.push(toolbarRemoveItems);
      }

      //The Bench Temple must be pending to be ready to be benched
      if (showReadyToBenchBtn) {
        var toolbarReadyToBench: ToolbarItem = {
          text: 'Ready To Bench',
          icon: faUpload,
          hasMultiple: false,
          cssClass: "purpleBg",
          action: () => { this.openConfirmDialog("Ready To Bench", ""); }
        };

        var items = this.toolbarItems;
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.push(toolbarReadyToBench)
      }

      if (showAssignBtn) {
        var toolbarAssign: ToolbarItem = {
          text: 'Assign',
          icon: faUpload,
          hasMultiple: false,
          cssClass: "purpleBg",
          action: () => { this.openConfirmDialog("offically to Ready to Bench", ""); }
        };

        var items = this.toolbarItems;
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.push(toolbarAssign)
      }

      if (showBenchedBtn) {
        var toolbarBench: ToolbarItem = {
          text: 'Bench',
          icon: faUpload,
          hasMultiple: false,
          cssClass: "orangeBg",
          action: () => { this.openConfirmDialog("Benched", ""); }
        };

        var items = this.toolbarItems;
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.push(toolbarBench);
      }

      if (showFinalizedBtn) {
        var toolbarFinalize: ToolbarItem = {
          text: 'Finalize',
          icon: faUpload,
          hasMultiple: false,
          cssClass: "redLightBg",
          action: () => { this.openConfirmDialog("Finalize", this.finalizeWarningDescription); }
        };

        var items = this.toolbarItems;
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.push(toolbarFinalize)
      }

      //remove save button
      if (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) {
        var items = this.toolbarItems;
        var saveBtn = this.toolbarItems.findIndex(t => t.text == "Save");
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.pop()
        this.toolbarItems.splice(saveBtn);
      }
    }
  }

  preSave(formControls: { [k: string]: FormControl }): void {
    var organizationId = this.auth.getOrganizationId();
    formControls['organizationId'] = new FormControl(organizationId);
  }

  override initializeUiControls() {

    var session = this.auth.getSession();

    const view = new ViewControl("Details");
    const details = new UiGroupControl("", "Details");
    const contactDetails = new UiGroupControl("", "Final Shipping Contact & Address");

    var clientEngineerFilters: AuthUserFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    const projectName = new TextControl("orderNumber", "Project Name", "");
    projectName.addOption(new ReadOnlyIf(() => { return true }));

    const finalSiteMac = new TextControl("finalSiteMac", "Final Site MAC", "");
    finalSiteMac.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));
    finalSiteMac.addOption(new RequiredIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Benched)) : false);
    }));

    const finalOnSiteRecipientPhoneNumber = new TextControl("recipientPhone", "Final On-Site Recipient Phone Number", "");
    finalOnSiteRecipientPhoneNumber.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const finalOnSiteRecipientEmail = new TextControl("recipientEmail", "Final On-Site Recipient Email", "");
    finalOnSiteRecipientEmail.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const specialDeliveryInstuctions = new TextAreaControl("deliveryInstructions", "Special Delivery Instuctions", "");
    specialDeliveryInstuctions.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const engineerEmailAddress = new ClientEngineerSelect("clientEngineerId", "Engineer E-mail Address", null);
    engineerEmailAddress.filters = clientEngineerFilters;
    engineerEmailAddress.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const requiredOnSiteDate = new DateControl("siteDate", "Required On Site Date (new)", null);
    requiredOnSiteDate.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const epcEngineerEmailAddress = new EpcEngineerSelect("epcEngineerId", "EPC Engineer E-mail Address", null);

    epcEngineerEmailAddress.addOption(new VisibleProperty((): boolean => { return this.canAssignEPCEngineerToBenchTemplate }));
    epcEngineerEmailAddress.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || !this.canAssignEPCEngineerToBenchTemplate;
    }));

    const line1 = new TextControl("line1", "Address", "");
    line1.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));
    line1.addOption(new RequiredIf(() => {
      return true;
    }));

    const line2 = new TextControl("line2", "Apartment, suite, stc. (optional)", "");
    line2.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    const city = new TextControl("city", "City", "");
    city.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));
    city.addOption(new RequiredIf(() => {
      return true;
    }));

    const postalCode = new TextControl("postalCode", "Postal Code", "");
    postalCode.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));
    postalCode.addOption(new RequiredIf(() => {
      return true;
    }));

    this.stateSelect = new StateSelect("stateId", "State", null);
    this.stateSelect.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));
    this.stateSelect.addOption(new RequiredIf(() => {
      return true;
    }));

    const countrySelect = new CountrySelect("countryId", "Country", null);
    countrySelect.onchange = (args: OnChangeArgs) => { this.onCountryChange(args); }

    var countryFilter: CountryFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    countrySelect.filters = countryFilter;

    countrySelect.addOption(new ReadOnlyIf(() => {
      return (this.entity != undefined ? (this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Finalized) || this.entity.benchTemplateStatusId == Number(BenchTemplateStatus.Cancelled)) : false) || this.isEpcEngineer;
    }));

    countrySelect.addOption(new RequiredIf(() => {
      return true;
    }));

    var row1 = new ViewRowControl();
    row1.controls.push(projectName, finalSiteMac);

    var row2 = new ViewRowControl();
    row2.controls.push(engineerEmailAddress, epcEngineerEmailAddress);

    var row3 = new ViewRowControl();
    row3.controls.push(requiredOnSiteDate, specialDeliveryInstuctions);

    var rowLine1 = new ViewRowControl();
    rowLine1.controls.push(line1, line2);

    var rowCity = new ViewRowControl();
    rowCity.controls.push(city, postalCode);

    var rowState = new ViewRowControl();
    rowState.controls.push(this.stateSelect, countrySelect);

    var rowPhone = new ViewRowControl();
    rowPhone.controls.push(finalOnSiteRecipientPhoneNumber, finalOnSiteRecipientEmail);


    details.rows.push(row1, row2, row3);
    contactDetails.rows.push(rowLine1, rowCity, rowState, rowPhone);

    view.controls.push(details, contactDetails);
    this.views.push(view);
  }

  onCellClicked(e: CellClickEvent): void {
    this.selectedRow = e.dataItem;

    // Handle Row Selection
    // We need to do custom row selection logic because selecting a row by right-click is not supported.
    // This will handle single row selection, and multi selection using the shift key or ctrl key.
    if (e.rowIndex != undefined) {
      var firstRowIndex = this.lastSelectedRowIndex;
      var lastRowIndex = e.rowIndex;

      var rightClick = window.event !== undefined && (window.event as PointerEvent).which == 3;
      var multiSelectWithCtrl = this.lastPointerEvent != null && this.lastPointerEvent.ctrlKey;
      var multiSelectWithShift = this.lastPointerEvent != null && this.lastPointerEvent.shiftKey;

      if (this.lastPointerEvent == undefined && window.event !== undefined && window.event instanceof PointerEvent) {
        this.lastPointerEvent = window.event;
      }

      if (rightClick) {
        if (!this.mySelection.includes(lastRowIndex)) {
          this.mySelection.push(lastRowIndex);
        }
      } else if (multiSelectWithShift) {
        var selectedIndexes = this.range(firstRowIndex, lastRowIndex);
        this.mySelection = [];
        Array.prototype.push.apply(this.mySelection, selectedIndexes);
      } else if (multiSelectWithCtrl) {
        this.mySelection.push(lastRowIndex);
      } else {
        this.mySelection = [];
        this.mySelection.push(lastRowIndex);
      }
    }

    this.lastSelectedRowIndex = e.rowIndex;
    this.lastSelectedColumnName = e.column.field;
    this.lastSelectedItem = e.dataItem;

    if (e.type == "contextmenu") {
      e.originalEvent.preventDefault();

      this.gridContextMenu.show({
        left: e.originalEvent.pageX,
        top: e.originalEvent.pageY
      });
    }
  }

  copyUniqnums() {
    var itemCount = this.entity.benchTemplateItems.map(e => e.epcUniqueIdentifier).join(",");
    this.clipboard.copy(itemCount);
  }


  private range(start: number, end: number): number[] {
    if (end > start) {
      return Array
        .apply(null, Array((end - start) + 1))
        .map(function (_, n) { return n + start; });
    } else {
      return Array
        .apply(null, Array((start - end) + 1))
        .map(function (_, n) { return n + end; });
    }
  }


  onContextMenuSelect(e: ContextMenuSelectEvent) {
    if (e.item && e.item.data.action) {
      e.item.data.action(e.item.data.params);
    }
  }

  copyText(): void {
    var value: string = "";
    if (this.lastSelectedItem && this.lastSelectedColumnName) {
      value = this.lastSelectedItem[this.lastSelectedColumnName];
    }

    this.clipboard.copy(value);
  }

}


